export default function Input(theme) {
    return {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                  position: 'absolute',
                    top: '100%',
                    fontSize: '0.75rem',
                    marginLeft:'0px !important'
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root:{
                    borderRadius: '8px !important',
                    height: '42px',
                    backgroundColor: '#FFFFFF',
                    fontFamily: '"Lato"',
                    color: '#29292a',
                    fontSize:'14px !important',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: `${theme.palette.borderColor} !important`,
                        borderWidth: '1.5px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: `${theme.palette.primary.darker} !important`,
                        borderWidth: '1.5px !important',
                    },
                    '&:has(input:invalid) .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d32f2f !important',
                        borderWidth: '1px !important',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d32f2f !important',
                        borderWidth: '1px !important',
                    },
                    '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px #FFFFFF inset !important',
                        WebkitTextFillColor: '#191a1c !important',
                        borderRadius: 'inherit',
                    },
                    '&.MuiInputBase-adornedStart': {
                        paddingLeft: '12px', 
                    },
                    '&.MuiInputBase-adornedEnd': {
                        paddingRight: '12px',
                    },
                },
            }
        }
    };
}